export default function MentionsLegales() {
  return (
    <div className="page">
      <div className="card">
        <h1>Mentions légales</h1>

        <p>
          <strong>Éditeur du site :</strong>
        </p>
        <p>Nom : Alexis Thery Email : contact@tonsite.fr</p>

        <p>
          <strong>Hébergement :</strong>
        </p>
        <p>
          Hébergeur : OVH
          <br />2 rue Kellermann – 59100 Roubaix – France
        </p>

        <p>
          <strong>Responsabilité :</strong>
        </p>
        <p>
          Les informations fournies sur ce site sont données à titre indicatif.
          L’éditeur ne saurait être tenu responsable des décisions prises sur la
          base des résultats fournis.
        </p>
      </div>
    </div>
  );
}
